var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "background-color": "white" } },
    [
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "py-1", staticStyle: { "align-items": "center" } },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c("div", { staticClass: "caption secondary--text mr-3" }, [
            _vm._v("\n      " + _vm._s(_vm.currentPage) + "\n      "),
            _vm.value && _vm.value.total
              ? _c("span", [
                  _vm._v(
                    "\n        of " + _vm._s(_vm.value.total) + "\n      "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "ml-3",
              attrs: { disabled: !_vm.canPrevious, icon: "" },
              on: {
                click: function ($event) {
                  return _vm.previous()
                },
              },
            },
            [_c("v-icon", { attrs: { color: "" } }, [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { disabled: !_vm.canNext, icon: "" },
              on: {
                click: function ($event) {
                  return _vm.next()
                },
              },
            },
            [_c("v-icon", { attrs: { color: "" } }, [_vm._v("chevron_right")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }